/**
 * @file コンポーネント：フル動画ページ評価ボタン DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledButton, StyledButtonCount } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    return (
        <StyledButton
            className={props.isRate && "is-rate"}
            onClick={() => props.fnOnClickButton()}
            title={
                props.isRate
                    ? localized["Label.RateRemove"]
                    : localized["Label.RateAdd"]
            }
        >
            {props.isRate ? (
                // 評価済み
                <>
                    <i className="fas fa-thumbs-up"></i>
                    {props.isCollaboration ? (
                        <></>
                    ) : (
                        <StyledButtonCount>{props.rateCount}</StyledButtonCount>
                    )}
                </>
            ) : (
                // 未評価
                <>
                    <i className="far fa-thumbs-up"></i>
                    {props.isCollaboration ? (
                        <></>
                    ) : (
                        <StyledButtonCount>{props.rateCount}</StyledButtonCount>
                    )}
                </>
            )}
        </StyledButton>
    );
};
